import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { KitReturnStatusMessages, MissingProductCard, ScannedKitEquipmentCard } from '../kit-return/shared/kit-return-ui';
import { useConfirmKitReturn } from './confirm-kit-return.controller';

const ID = 'confirm-kit-return';

export const ConfirmKitReturn = () => {
    const viewProps = useConfirmKitReturn();

    return (
        <WizardScreenContainer
            id={ID}
            header={{
                onBack: viewProps.onBack
            }}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled
            }}
            loadingModal={{
                show: viewProps.status.kind === 'loading' || viewProps.isSubmitting || viewProps.isAuthenticatingUser || viewProps.isCheckingSlotAvailability
            }}
            errorModal={{
                show: !!viewProps.error,
                title: viewProps.errorTitle ?? (
                    <FormattedMessage
                        id='kiosk.wizard.kit-return-detail.cannot-continue-title'
                        description='Fallback title shown when a kit return cannot continue'
                        defaultMessage='Cannot continue'
                    />
                ),
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-start justify-start gap-2 self-stretch overflow-y-scroll p-0'>
            <div className='flex flex-1 flex-col items-start justify-start gap-2 self-stretch px-5 pt-6 pb-20'>
                <div className='mb-2 flex items-start justify-start self-stretch'>
                    <div className='text-foreground-default justify-start text-base font-medium'>
                        <FormattedMessage
                            id='kiosk.wizard.confirm-kit-return.scan-items'
                            description='Informative text asking the user to scan items in the kit to return'
                            defaultMessage='Scan the items you want to return'
                        />
                    </div>
                </div>

                <KitReturnStatusMessages
                    status={viewProps.status}
                    retryLoad={viewProps.retryLoad}
                />

                {viewProps.status.kind === 'ready' &&
                    viewProps.entries.map((entry) => {
                        const scannedForEntry = viewProps.scansByProductId.get(entry.product.id) ?? [];
                        const scannedCount = scannedForEntry.length;

                        return (
                            <div
                                key={entry.product.id}
                                className='flex w-full flex-col gap-2'>
                                {scannedForEntry.map((equipment, index) => (
                                    <ScannedKitEquipmentCard
                                        key={equipment.id}
                                        entry={entry}
                                        equipment={equipment}
                                        scanIndex={index}
                                        scannedCount={scannedCount}
                                        onRemove={() => viewProps.removeScan(equipment.id)}
                                    />
                                ))}
                                {scannedCount === 0 && (
                                    <MissingProductCard
                                        entry={entry}
                                        scannedCount={0}
                                        missingCount={entry.quantity}
                                    />
                                )}
                            </div>
                        );
                    })}

                {/* {!viewProps.isAuthenticated && (
                    <div className='bg-brand-primary flex w-full items-center justify-center rounded-xl p-4'>
                        <SignInCta
                            iconSize='small'
                            title={
                                <FormattedMessage
                                    id='kiosk.wizard.confirm-kit-return.scan-badge-title'
                                    description='Title shown on the kit return screen when the user can authenticate to pick a SLOT'
                                    defaultMessage='Scan your badge to choose a SLOT'
                                />
                            }
                            subtitle={
                                viewProps.requiresAuthenticationForSlot ? (
                                    <FormattedMessage
                                        id='kiosk.wizard.confirm-kit-return.scan-badge-required-subtitle'
                                        description='Subtitle shown when there is no empty SLOT available for an unauthenticated kit return'
                                        defaultMessage='No empty SLOT is available. Badge to continue.'
                                    />
                                ) : (
                                    <FormattedMessage
                                        id='kiosk.wizard.confirm-kit-return.scan-badge-subtitle'
                                        description='Subtitle shown on the kit return screen before authentication'
                                        defaultMessage='Authenticated users can select an available SLOT manually.'
                                    />
                                )
                            }
                        />
                    </div>
                )} */}
            </div>
        </WizardScreenContainer>
    );
};

export default ConfirmKitReturn;
